const formatDateRegular = () => {
  const dateLocal = new Date();
  return dateLocal.getUTCMonth() < 9
    ? `${dateLocal.getUTCFullYear()}-0${dateLocal.getUTCMonth() + 1}-${
        dateLocal.getUTCDate() > 9 ? dateLocal.getUTCDate() : '0' + dateLocal.getUTCDate()
      }`
    : `${dateLocal.getUTCFullYear()}-${dateLocal.getUTCMonth() + 1}-${dateLocal.getUTCDate()}`;
};

export {formatDateRegular}